export default __webpack_public_path__ + "static/media/edit.701c2440.svg";